import React from 'react';
import { Logo } from '../Logo';
import { SignupAudience } from '../../types/signup';
export function LandingNav({
  onSignup
}: {
  onSignup: (a: SignupAudience) => void;
}) {
  return <header className="sticky top-0 z-40 border-b border-line bg-canvas/90 backdrop-blur" data-id="element-138" data-mp="2zyuzxe9sdqm2">
      <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6" aria-label="Main" data-id="element-139" data-mp="2v01ixbvajhh5">
        <Logo data-id="element-140" data-mp="2q0oysyvt0oi9" />
        <div className="flex items-center gap-2" data-id="element-141" data-mp="2q172uhopk70q">
          <button onClick={() => onSignup('company')} className="hidden whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-muted transition-colors duration-150 hover:text-ink sm:block" data-id="element-142" data-mp="2pyuadalbqe9f">
            For companies
          </button>
          <button onClick={() => onSignup('gigs')} className="whitespace-nowrap rounded-full bg-ink px-4 py-2 text-sm font-medium text-canvas transition-transform duration-150 ease-out active:scale-[0.97]" data-id="element-143" data-mp="2c2qmdz11n25e">
            Get early access
          </button>
        </div>
      </nav>
    </header>;
}